module.exports = __webpack_public_path__ + "v.no2.335938f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/v.no2.jpg
// module id = Ur6k
// module chunks = 0